import { Component, EventTarget, _decorator } from 'cc';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';

const { ccclass, requireComponent } = _decorator;

@ccclass('FullscreenPage')
@requireComponent(Page)
export default class FullscreenPage extends Component {
    public static readonly EVENT_TARGET: EventTarget = new EventTarget();
    public static readonly EVENT_INSTANCE_ADDED: string = 'fullscreen-page-instance-added';
    public static readonly INSTANCES: Page[] = [];

    protected onLoad() {
        FullscreenPage.INSTANCES.push(this.getComponent(Page));
        FullscreenPage.EVENT_TARGET.emit(FullscreenPage.EVENT_INSTANCE_ADDED);
    }
}
